<template>
  <div class="content surveryEr">
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>能耗管理</el-breadcrumb-item>
            <el-breadcrumb-item>能耗监测</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 3vh);width:100%;position: relative;">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;overflow-y: auto;" class="aside">
          <div  class="title">
            <div>用水量: <img src="../../assets/image/wa.png" style="width:20px;height:20px" alt=""></div>
            <div>用电量: <img src="../../assets/image/electric.png" style="width:20px;height:20px" alt=""></div>
          </div>
          <el-calendar v-model="value" id="calendar" :first-day-of-week="7">
            <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
            <template slot="dateCell" slot-scope="{date, data}">
              <!--自定义内容-->
              <div>
                <div class="calendar-day">{{ data.day.split('-').slice(2).join('-') }}</div>
                <div v-for="(item,index) in calendarData" :key="index">
                  <div v-if="item.time == data.day && new Date().getTime()>new Date(item.time).getTime()">
                    <!-- <div v-if="(item.days).indexOf(data.day.split('-').slice(2).join('-'))!=-1"> -->
                      <el-tooltip
                        class="item"
                        effect="dark"
                        placement="right"
                      >
                        <div slot="content">用电量：{{item.ele}} KW<br/>用水量：{{item.water}} T<br/>总用电量：{{item.eleAll}} KW<br/>总用水量：{{item.waterAll}} T</div>
                        <div class="is-selected">
                          <div style="width:50%">
                              <img src="../../assets/image/electric.png" style="width:20px;height:20px" alt="" srcset=""> 
                              <span style="width:50px"> {{item.ele}} KW</span> <br> 
                              <img src="../../assets/image/wa.png"  style="width:20px;height:20px"  alt="" srcset="">
                              <span style="width:50px"> {{item.water}} T</span>
                          </div>
                          <div style="width:40%">
                             <img v-if="item.eleType==-1" src="../../assets/image/down.png" style="width:10px;height:10px" alt="" srcset=""> 
                             <img v-else-if="item.eleType==1" src="../../assets/image/up.png" style="width:10px;height:10px" alt="" srcset=""> 
                             <span v-if="item.eleVal&&item.eleVal!=0">{{item.eleVal}}%</span> <br>
                             <img v-if="item.waterType==-1" src="../../assets/image/down.png" style="width:10px;height:10px" alt="" srcset="">
                             <img v-if="item.waterType==1" src="../../assets/image/up.png" style="width:10px;height:10px" alt="" srcset=""> 
                             <span v-if="item.waterVal&&item.waterVal!=0">{{item.waterVal}}%</span> 
                          </div>
                          <div style="width:100%;height:6vh;position: relative;">
                            <p style="width:100%;height:3vh;color: #f7bf27;"><img src="../../assets/image/eleAll.png" style="width:20px;height:20px" alt="" srcset=""> {{item.eleAll}} KW</p>
                            <p style="width:100%;height:3vh;color: #0593ee;"><img src="../../assets/image/waterAll.png" style="width:20px;height:20px" alt="" srcset=""> {{item.waterAll}} T</p>
                          </div>
                        </div>
                        <!--  -->
                      </el-tooltip>
                  </div>
                  <div v-else></div>
                </div>
              </div>
            </template>
          </el-calendar>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base.js'


var _index
export default {
  data() {
    return {
      calendarData: [
        // {
        //   months: ['12'],
        //   days: ['15', '02', '01', '03', '04', '05', '06'],
        //   things1: '568WH',
        //   things2:'68T',
        //   rateUp:'1.05%',
        //   rateDown:'0.05%',
        // },
        // {
        //   months: ['06'],
        //   days: ['15', '02', '01', '03', '04', '05', '06'],
        //   things1: '568WH',
        //   things2:'68T',
        //   rateUp:'1.05%',
        //   rateDown:'0.05%',
        // }
      ],
      listData:[],//准备值
      value: new Date(),
      groupId:'',
      year:new Date().getFullYear(),
    }
  },
  created: function() {
    this.$nextTick(() => {
      // 点击前一个月
      let prevBtn = document.querySelector( ".el-calendar__button-group .el-button-group>button:nth-child(1)" );
      prevBtn.addEventListener("click", e => {
        // console.log(util.myTime.getCurTime(new Date(this.value).getTime()));
        this.getData()
      });
    
      //点击下一个月
      let nextBtn = document.querySelector( ".el-calendar__button-group .el-button-group>button:nth-child(3)");
      nextBtn.addEventListener("click", () => {
        // console.log(util.myTime.getCurTime(new Date(this.value).getTime()));
        this.getData()
      });
    
      //点击今天
      let todayBtn = document.querySelector( ".el-calendar__button-group .el-button-group>button:nth-child(2)" );
      todayBtn.addEventListener("click", () => {
        // console.log(util.myTime.getCurTime(new Date(this.value).getTime()));
        this.getData()
      });
    });
  },
  mounted() {
    this.groupId = util.session.get('groupId')
    this.getData()
  },
  methods: {
    // 搜索数据 111
    doFilter() {
    },
    //判断增长或者减少
    getBilv(val1,val2){
      var result = 0
      // if(parseInt(val1)==0){
      //   result = 0
      // }else
      if(parseInt(val1)>parseInt(val2)){
        result = -1
      }else if(parseInt(val1)<parseInt(val2)){
        result = 1
      }
      return result
    },
    getBilvVal(val1,val2){
      var result = 0
      if(parseInt(val1)==0 && parseInt(val2)>0){
        result = 100
      }else if(parseInt(val1)>parseInt(val2)){
        result = (((parseInt(val1)-parseInt(val2))/parseInt(val1))*100).toFixed(0)
      }else if(parseInt(val1)<parseInt(val2)){
        result = (((parseInt(val2)-parseInt(val1))/parseInt(val1))*100).toFixed(0)
      }
      return result
    },
    //获取数据
    getData(){
      var that = this
      this.listData = []
      myHttp.selectWaterByMonth({
        projectId:this.groupId,
        time:util.myTime.formatTime(new Date(this.value).getTime(),'YYYY-MM'),
        type:'1',  //水
      }).then(function(resp){
        if(resp.data.code=='200'){
          var list = resp.data.data.monthWater||[]
          for(var i=0;i<list.length;i++){
            var type = 0
            var bilv = 0
            if(i>0){
              type = that.getBilv(list[i-1].calculateUseOf,list[i].calculateUseOf)
              bilv = that.getBilvVal(list[i-1].calculateUseOf,list[i].calculateUseOf)
            }
            var obj = {
              time:list[i].time,
              water:list[i].calculateUseOf,
              waterType:type,
              waterVal:bilv,
              waterAll:list[i].useOf
            }
            that.listData.push(obj)
          }
        }
        that.getEleData()
      })
    },

    //获取电数据
    getEleData(){
      var that = this
      myHttp.selectWaterByMonth({
        projectId:this.groupId,
        time:util.myTime.formatTime(new Date(this.value).getTime(),'YYYY-MM'),
        type:'2',  //电
      }).then(function(resp){
        if(resp.data.code=='200'){
          var list = resp.data.data.monthWater||[]
          for(var i=0;i<list.length;i++){
            var type = 0
            var bilv = 0
            if(i>0){
              type = that.getBilv(list[i-1].calculateUseOf,list[i].calculateUseOf)
              bilv = that.getBilvVal(list[i-1].calculateUseOf,list[i].calculateUseOf)
            }
            that.listData[i].ele =  list[i].calculateUseOf
            that.listData[i].eleType =  type
            that.listData[i].eleVal =  bilv
            that.listData[i].eleAll = list[i].useOf
            // var obj = {
            //   time:list[i].time,
            //   water:list[i].calculateUseOf,
            //   waterType:type,
            //   waterVal:bilv,
            // }
            // that.calendarData.push(obj)
          }
          
        }
        that.calendarData = that.listData
      })
    },

    showFun(obj){
      // console.log(obj)
      //console.log(util.myTime.getCurTime(new Date(obj).getTime()))
    },

  }
}
</script>
<style>
  @import '../../assets/css/common.css';
  .surveryEr .el-calendar-table .el-calendar-day{
    height: 160px;
  }
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.is-selected {
  color: #000;
  /* margin: 10px 40px; */
  padding: 20px 10px 0;
  text-align: left;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.title{
  display: flex;
  width: 200px;
    position: absolute;
    top: 14px;
    /* left: 0px; */
    right: 250px;
    justify-content: space-between;
    align-items: center;
}
</style>